import React from 'react';

import '../sass/HighlightedBoardgame.sass';
import PlayTime from './PlayTime';
import Players from './Players';

const HighlightedBoardgame = ({ title, image, minPlayers, maxPlayers, minPlayTime, maxPlayTime }) => {
  return (
    <div className="sg-highlighted-bg relative w-48 h-64 md:w-64 md:h-64 rounded-lg shadow-md bg-cover bg-no-repeat bg-center md:bg-top flex-shrink-0" style={{ backgroundImage: `url('${image}')` }}>
      <div className="sg-highlighted-bg__overlay absolute flex flex-col justify-end p-4 rounded-lg w-48 h-64 md:w-64 md:h-64 bg-gray-100 inset-0">
        <h1 className="text-white font-serif font-black leading-tight">{ title }</h1>
        <div className="flex mt-2">
          <PlayTime minPlayTime={minPlayTime} maxPlayTime={maxPlayTime} iconSize={18} iconColour="#FFFFFF" textColourClass="text-white" textSizeClass="text-xs" marginClasses="mr-2" />
          <Players minPlayers={minPlayers} maxPlayers={maxPlayers} iconSize={18} iconColour="#FFFFFF" textColourClass="text-white" textSizeClass="text-xs" />
        </div>
      </div>
    </div>
  );
};

export default HighlightedBoardgame;
